import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Tabs, Tab, Button, Offcanvas, Card } from 'react-bootstrap';
import transaction from "../../actions/transaction";
import {ReactComponent as InfoSvg} from './../../assets/icons/svg/info.svg';
import {ReactComponent as UserSvg} from './../../assets/icons/svg/user.svg';
import {ReactComponent as KeySvg} from './../../assets/icons/svg/keys.svg';
import ListPickup from "../../components/ListPickup";
import { toast } from 'react-toastify';
import moment from 'moment';
import auths from "../../actions/auth";
import master from "../../actions/master";
import ListNotif from "../../components/ListNotif";


export default function Notifikasi() {
  const navigate = useNavigate();
  const [notifTr, setNotifTr] = useState([]);
  const [notifReq, setNotifReq] = useState([]);
  const [notifPick, setNotifPick] = useState([]);
  const [notifPickup, setNotifPickup] = useState([]);
  const [notifDep, setNotifDep] = useState([]);
  const [notifVerif, setNotifVerif] = useState([]);
  const [loading, setLoading] = useState(true);

   useEffect(() => {
      setLoading(true)
      master.actions.get_notification().then((res) => {
         setNotifTr(res?.data?.data?.transaction);
         setNotifReq(res?.data?.data?.pickup_request);
         setNotifPick(res?.data?.data?.request_pickup);
         setNotifPickup(res?.data?.data?.pickup);
         setNotifDep(res?.data?.data?.trash_deposit);
         setNotifVerif(res?.data?.data?.client_verify);
         setLoading(false)
      });
  },[]);

  const readNotif = (data) => {
   master.actions.post_read_notification(data?.id).then((res) => {
      master.actions.get_notification().then((res) => {
         setNotifTr(res?.data?.data?.transaction);
         setNotifReq(res?.data?.data?.pickup_request);
         setNotifDep(res?.data?.data?.trash_deposit);
         setNotifVerif(res?.data?.data?.client_verify);
         setNotifPick(res?.data?.data?.request_pickup);
         setNotifPickup(res?.data?.data?.pickup);
      });
   });

   // console.log(data?.data?.meta?.event)

   if(data?.data?.meta?.event === 'new.trash_deposit'){
      navigate(`/cart`)
   }

   if(data?.data?.meta?.event === 'confirmed.pickup_request'){
      navigate(`/trash`)
   }

   if(data?.data?.meta?.event === 'done.pickup_request'){
      navigate(`/trash/done`)
   }

   if(data?.data?.meta?.event === 'pickup.canceled'){
      navigate(`/trash/cancel`, )
   }

   if(data?.data?.meta?.event === 'client.verify'){
      navigate(`/partner/verify`, )
   }

   if(data?.data?.meta?.event === 'success.deposit'){
      navigate(`/mutation/${data?.data?.meta?.partner_id}/history`, )
   }

   if(data?.data?.meta?.event === 'success.withdraw'){
      navigate(`/mutation/${data?.data?.meta?.partner_id}/history`, )
   }

   if(data?.data?.meta?.event === 'success.request_pickup'){
      navigate(`/trash`)
   }

  }

   
  return (
   <div className="bg-light vh-100">
       <div className="fixed-top header bg-light">
         <div className="text-center fw-semibold">
               Notifikasi
         </div>
         <Button className="btn btn-icon btn-success btn-sm btn-radius btn-nav-back" onClick={() => navigate(-1)}>
               <i className="ph-arrow-left text-light"></i>
         </Button>
      </div>
      {notifTr || notifReq || notifPick || notifPickup || notifDep || notifVerif ?
      <div className="mt-5 py-5">
         {notifTr ?
         <Card className="m-4 card-notification">
            <Card.Body>
               <div className="text-secondary ts-ssm fw-semibold pt-1 pb-3 border-bottom">
                  Transaksi
               </div>
               {loading ?
               <div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
               </div>:
               <div>
                  {notifTr.length > 0 ?
                     <>
                        {notifTr.map((item,key)=>{
                           return <ListNotif onClick={() => readNotif(item)} type="transaction" data={item} key={key}/>
                        })}
                     </>:
                     <div className=" py-5 text-center ts-sm text-secondary">
                        Tidak ada notifikasi terbaru
                     </div>
                  }
               </div>
               }
            </Card.Body>
         </Card> : null   
         }
         { notifReq ?
          <Card className="m-4 card-notification">
            <Card.Body>
               <div className="text-secondary ts-ssm fw-semibold pt-1 pb-3 border-bottom">
                  Request Penjemputan
               </div>
               {loading ?
               <div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
               </div>:
               <div>
                  {notifReq.length > 0 ?
                     <>
                        {notifReq.map((item,key)=>{
                           return <ListNotif onClick={() => readNotif(item)} type="request" data={item} key={key}/>
                        })}
                     </>:
                     <div className=" py-5 text-center ts-sm text-secondary">
                        Tidak ada notifikasi terbaru
                     </div>
                  }
               </div>
               }
            </Card.Body>
          </Card> : null
         }
         
         { notifPick ?
          <Card className="m-4 card-notification">
            <Card.Body>
               <div className="text-secondary ts-ssm fw-semibold pt-1 pb-3 border-bottom">
                  Request Penjemputan
               </div>
               {loading ?
               <div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
               </div>:
               <div>
                  {notifPick.length > 0 ?
                     <>
                        {notifPick.map((item,key)=>{
                           return <ListNotif onClick={() => readNotif(item)} type="request" data={item} key={key}/>
                        })}
                     </>:
                     <div className=" py-5 text-center ts-sm text-secondary">
                        Tidak ada notifikasi terbaru
                     </div>
                  }
               </div>
               }
            </Card.Body>
          </Card> : null
         }

         { notifPickup ?
          <Card className="m-4 card-notification">
            <Card.Body>
               <div className="text-secondary ts-ssm fw-semibold pt-1 pb-3 border-bottom">
                  Request Penjemputan
               </div>
               {loading ?
               <div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
               </div>:
               <div>
                  {notifPickup.length > 0 ?
                     <>
                        {notifPickup.map((item,key)=>{
                           return <ListNotif onClick={() => readNotif(item)} type="request" data={item} key={key}/>
                        })}
                     </>:
                     <div className=" py-5 text-center ts-sm text-secondary">
                        Tidak ada notifikasi terbaru
                     </div>
                  }
               </div>
               }
            </Card.Body>
          </Card> : null
         }

         { notifDep ?
          <Card className="m-4 card-notification">
            <Card.Body>
               <div className="text-secondary ts-ssm fw-semibold pt-1 pb-3 border-bottom">
                  Request Penjemputan
               </div>
               {loading ?
               <div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
               </div>:
               <div>
                  {notifDep.length > 0 ?
                     <>
                        {notifDep.map((item,key)=>{
                           return <ListNotif onClick={() => readNotif(item)} type="request" data={item} key={key}/>
                        })}
                     </>:
                     <div className=" py-5 text-center ts-sm text-secondary">
                        Tidak ada notifikasi terbaru
                     </div>
                  }
               </div>
               }
            </Card.Body>
          </Card> : null
         }

         { notifVerif ?
          <Card className="m-4 card-notification">
            <Card.Body>
               <div className="text-secondary ts-ssm fw-semibold pt-1 pb-3 border-bottom">
                  Status Verifikasi
               </div>
               {loading ?
               <div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
                  <div className="skeleton skeleton-bar mb-3"></div>
               </div>:
               <div>
                  {notifVerif.length > 0 ?
                     <>
                        {notifVerif.map((item,key)=>{
                           return <ListNotif onClick={() => readNotif(item)} type="request" data={item} key={key}/>
                        })}
                     </>:
                     <div className=" py-5 text-center ts-sm text-secondary">
                        Tidak ada notifikasi terbaru
                     </div>
                  }
               </div>
               }
            </Card.Body>
          </Card> : null
         }
      </div> : 
      <div className="h-100 d-flex align-items-center justify-content-center text-center ts-sm text-secondary">
         Tidak ada notifikasi terbaru
      </div>
      }

   </div>
  );
}